import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class Notification {
  private toastrService = inject(ToastrService);

  success(title = `Success!`, message = 'successful') {
    this.toastrService.success(message, title);
  }

  info(title = `Info`, message = '') {
    this.toastrService.info(message, title, {
      closeButton: true,
      timeOut: 10000,
    });
  }

  warning(title = `Warning!`, message = 'please try again') {
    this.toastrService.warning(message, title, {
      closeButton: true,
      timeOut: 10000,
    });
  }

  error(title = `Error`, message = 'please try again') {
    this.toastrService.error(message, title, {
      closeButton: true,
      timeOut: 10000,
    });
  }
}
